export const SECTION_SCHEDULE_ENDPOINTS = {
  GET_SCHEDULES: '/api/admin/product/section/schedule',
  GET_SCHEDULE: (id: number) => `/api/admin/product/section/schedule/${id}`,
  CREATE_SCHEDULE: '/api/admin/product/section/schedule',
  UPDATE_SCHEDULE: (id: number) => `/api/admin/product/section/schedule/${id}`,
  DELETE_SCHEDULE: (id: number) => `/api/admin/product/section/schedule/${id}`,
  GET_AVAILABLE_SECTIONS: '/api/admin/product/section/schedule/availableSections',
  FORCE_EXECUTE: (id: number) => `/api/admin/product/section/schedule/forceExecute/${id}`,
  FORCE_TERMINATE: (id: number) => `/api/admin/product/section/schedule/forceTerminate/${id}`,
};
